import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { axInst } from "../../../Components/Login/Service";
import { Loader } from "rsuite";
import WaterMark from "../../../Components/WaterMark/WaterMark";

const PvinCustomerProfileApi = async (selectedFilter) => {
  try {
    const res = await axInst.post("pvin/customer-details", selectedFilter);
    return res.data;
  } catch (error) {
    console.error("Error fetching customer profile:", error.response || error);
    throw error;
  }
};

const fleetApi = async (selectedFilter) => {
  try {
    const res = await axInst.post("pvin/fleet-data", selectedFilter);
    return res.data;
  } catch (error) {
    console.error("Error fetching customer profile:", error.response || error);
    throw error;
  }
};

const AccountApi = async (selectedFilter) => {
  try {
    const res = await axInst.post("pvin/account-summary", selectedFilter);
    return res.data;
  } catch (error) {
    console.error("Error fetching customer profile:", error.response || error);
    throw error;
  }
};

const PvinCustomerProfile = () => {
  const selectedFilter = useSelector(
    (state) => state.filtersPvin.selectedFilter
  );

  const {
    data: pvindata,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["pvinCustomerData", selectedFilter], // refetch when filter changes
    queryFn: () => PvinCustomerProfileApi(selectedFilter),
    cacheTime: 0,
    staleTime: 0,
    enabled: Object.keys(selectedFilter).length > 0, // only call API if filter exists
  });

  const { data: fleetdata } = useQuery({
    queryKey: ["fleetData", selectedFilter], // refetch when filter changes
    queryFn: () => fleetApi(selectedFilter),
    cacheTime: 0,
    staleTime: 0,
    enabled: Object.keys(selectedFilter).length > 0, // only call API if filter exists
  });

  const { data: accountData } = useQuery({
    queryKey: ["accountData", selectedFilter], // refetch when filter changes
    queryFn: () => AccountApi(selectedFilter),
    cacheTime: 0,
    staleTime: 0,
    enabled: Object.keys(selectedFilter).length > 0, // only call API if filter exists
  });

  if (isFetching)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );

  if (isError)
    return (
      <div className="text-center text-red-500 p-4">Failed to load data.</div>
    );

  const customer = Array.isArray(pvindata) ? pvindata[0] : pvindata;

  if (!customer)
    return (
      <div className="text-center text-gray-600 bg-white p-2">
        No data available
      </div>
    );

  return (
    <div className="relative w-full shadow-lg rounded-md bg-white p-2 py-1 md:flex justify-between items-center block">
      <WaterMark />
      <div className="mt-2">
        <div className="font-semibold text-gray-800 text-2xl mb-1">
          {customer.PAR_ACCNT_NAME}
        </div>
        <div className="text-sm text-gray-600 flex gap-1 mb-4">
          <div>
            Arn : <span className="font-bold">{customer.PAR_ACCNT_ARN}</span>
          </div>
          |
          <div>
            Contact:
            {customer.PAR_ACCNT_MAIN_PH_NUM
              ? customer.PAR_ACCNT_MAIN_PH_NUM.replace(
                  /^(\d)(\d+)(\d{2})$/,
                  (_, first, middle, last) =>
                    first + "x".repeat(middle.length) + last
                )
              : "N/A"}
          </div>
          |<div> KA Code : {customer.PAR_ACCNT_LOCATION}</div>
        </div>
      </div>

      {/* Fleet bubbles */}
      {/* {fleetdata && (
        <div className="grid grid-cols-2 gap-1 ">
          {Object.entries(fleetdata).map(([key, value], index) => {
            if (value === null || value === undefined) return null;

            // Convert key to readable label
            const label = key
              .replace(/_/g, " ")
              .replace(/\b\w/g, (char) => char.toUpperCase());

            // Dynamic colors array
            const colors = [
              "bg-blue-500",
              "bg-green-500",
              "bg-indigo-500",
              "bg-red-500",
            ];
            const color = colors[index % colors.length]; // loop colors if more fields

            return (
              <div key={key} className="flex flex-col items-center">
                <div
                  className={`rounded-full flex items-center justify-center text-white font-bold py-[2px] px-2 text-center gap-[2px] ${color}`}
                >
                  <span className="text-xs">{label}</span>:
                  <span className="text-xs"> {value}</span>
                </div>
              </div>
            );
          })}
        </div>
      )} */}
      {/* Fleet + Account Bubbles */}
      <div className="grid grid-cols-2 gap-1">
        {/* ---- 3 Bubbles from accountData ---- */}
        {accountData && (
          <>
            {(() => {
              const account = Array.isArray(accountData)
                ? accountData[0]
                : accountData;

              const items = [
                { label: "Fleet Size", value: account?.fleet_size },
                {
                  label: "Last Purchase Date",
                  value: account?.last_Purchase_date,
                },
                {
                  label: "Last Purchase Model",
                  value: account?.Last_purchase_model,
                },
              ];

              const colors = ["bg-blue-500", "bg-green-500", "bg-indigo-500"];

              return items.map(
                (item, index) =>
                  item.value && (
                    <div key={index} className="flex flex-col items-center">
                      <div
                        className={`rounded-full flex items-center justify-center text-white font-bold py-[2px] px-2 text-center gap-[2px] ${colors[index]}`}
                      >
                        <span className="text-xs">{item.label}</span>:
                        <span className="text-xs">{item.value}</span>
                      </div>
                    </div>
                  )
              );
            })()}
          </>
        )}

        {/* ---- 1 Bubble from fleetdata ---- */}
        {fleetdata?.last_purchase_6_month !== undefined && (
          <div className="flex flex-col items-center">
            <div className="rounded-full flex items-center justify-center text-white font-bold py-[2px] px-2 text-center gap-[2px] bg-red-500">
              <span className="text-xs">Last 6 Month Purchase</span>:
              <span className="text-xs">{fleetdata.last_purchase_6_month}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PvinCustomerProfile;
